import './Fallback.css';

const Fallback = () => {
    return <h1 className='fallback' data-aos="zoom-out" data-aos-delay='300' data-aos-duration='600'>Geeks Invention</h1>
}

export default Fallback;